import {Component, OnInit, OnChanges, Input, OnDestroy} from '@angular/core';
import {NgForm} from '@angular/forms';
import {PropertyService} from '../../services/property.service';
import {Http, RequestOptions, Headers, Response} from '@angular/http';
import { ConstantsService } from '../../../../../services/constants.service';
import { environment } from 'environments/environment';
import {ApiClientService} from '../../../../../services/api-client.service';
import { AuthTokenService } from '../../../../../services/auth-token.service';
import {Theme} from '../../../../../types/admin-data.types';

declare const swal;
declare const toastr: any;

@Component({
    selector: 'property-info-view',
    templateUrl: './property-info-view.component.html',
    styleUrls: ['./property-info-view.component.scss']
})
export class PropertyInfoViewComponent implements OnInit, OnDestroy, OnChanges {
    @Input() data;
    public contacts = [];
    spinnerBackground: boolean = false;
    public addressTimeout = null;

    public theme: Theme = null;
    private customThemesSubscriber;

    constructor(
      public propertyService: PropertyService,
      public api: ApiClientService,
      private http: Http,
      private authTokenService: AuthTokenService
    ) {
    }

    ngOnInit() {
    }

    ngOnChanges() {
        this.data = null;
        setTimeout(() => {
            this.data = this.propertyService.selectedItemData;
            this.contacts = JSON.parse(JSON.stringify(this.data.contacts));
            this.customThemesSubscriber = this.propertyService.customThemes$.subscribe((customThemes: Theme[]) => {
                this.theme = customThemes.find(theme => +theme.buildingId === +this.data.id);
            })
        }, 0);
    }

    removeCustomTheme() {
        if (!this.theme) return;
        swal(ConstantsService.getSwalConfig(`Delete Theme?`), (event) => {
            if (event) {
                this.propertyService.removeCustomTheme(this.theme.id).subscribe(
                    res => { this.theme = null;},
                    error => toastr.error(error, 'Something Happened')
                )
            }
        })
    }

    update(changedData) {
        const dataKeys = Object.keys(changedData);

        if (changedData.contacts) {
            changedData.contacts.forEach(item => {
                for (const key in item) {
                    if (key === 'id') delete item[key];
                }
            });

        }
        this.setCompany(changedData);

        if (!dataKeys.every(key => changedData[key] === undefined)) {
            dataKeys.forEach(key => {
                if (changedData[key] === undefined) changedData[key] = '';
            });

            this.propertyService.update(this.data.id, changedData).subscribe((res) => {
                this.propertyService.get(+this.data.id);
            }, err => this.propertyService.spinnerShow = false);
        }
    }

    reset(field) {
        this.data[field] = '';
    }

    resetPhones(contacts) {
        this.contacts = JSON.parse(JSON.stringify(contacts));
    }

    onSubmit(form: NgForm) {
        this.update(form.value);
    }

    setCompany(data) {
        if (data.companyName) {
            data.companyName = data.companyId && this.propertyService.companies.find(item => Number(item.id) === Number(data.companyId)).name;
        }
    }

    changeBackground(e) {
        this.spinnerBackground = true;
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.http.post(`${environment.domainEmails}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('File path should not be blank.');
                    return;
                }
                this.propertyService.currentBackgroundIMG = res.path;
                this.propertyService.updateBuildingInfo({backgroundImage: this.propertyService.currentBackgroundIMG}).subscribe(
                    res => toastr.success('File has been uploaded'),
                    error => toastr.error(error, 'Something Happened')
               );
                this.spinnerBackground = false;
            },
            error => {
                toastr.error(error, 'Upload file failed');
                this.spinnerBackground = false;
            }
        );
    }

    removeBackground() {
        this.propertyService.currentBackgroundIMG = '';
        this.propertyService.updateBuildingInfo({backgroundImage: this.propertyService.currentBackgroundIMG}).subscribe(
            res => toastr.success('File deleted'),
            error => toastr.error(error, 'Something Happened')
        );
    }

    getCompanyNameById(id) {
        return this.propertyService.companies.find(c => c.id == id).name;
    }

    placeMarker(event) {
        this.addressTimeout = setTimeout(() => {
            const url = `${ConstantsService.googleMapsApi}geocode/json?latlng=${event.coords.lat},${event.coords.lng}&key=${ConstantsService.googleMapsApiKey}`;
            this.http.get(url).subscribe(
                response => {
                    const body = JSON.parse((<any>response)._body);
                    // this.data.address = body.results[0].formatted_address;
                    this.data.longitude = body.results[0].geometry.location.lng;
                    this.data.latitude = body.results[0].geometry.location.lat;
                    this.update({
                        // address: this.data.address,
                        longitude: this.data.longitude,
                        latitude: this.data.latitude
                    });
                },
                error => this.api.errorHandler(error, 'Failed to get addresss data from Google Maps API.')
            );
        }, 500);
    }

    mapDblClick() {
        if(this.addressTimeout)
            clearTimeout(this.addressTimeout);
    }

    resetMapCoordinates() {
        this.data.longitude = null;
        this.data.latitude = null;
        const url = `${ConstantsService.googleMapsApi}geocode/json?address=${this.data.address}&key=${ConstantsService.googleMapsApiKey}`;
        this.http.get(url).subscribe(
            response => {
                const body = JSON.parse((<any>response)._body);
                if(body.results[0]) {
                    this.data.longitude = body.results[0].geometry.location.lng;
                    this.data.latitude = body.results[0].geometry.location.lat;
                    this.update({
                        longitude: this.data.longitude,
                        latitude: this.data.latitude
                    });
                }
            },
            error => this.api.errorHandler(error, 'Failed to get addresss data from Google Maps API.')
        );
    }

    ngOnDestroy(): void {
        if (this.customThemesSubscriber) {
            this.customThemesSubscriber.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/property-info-view/property-info-view.component.ts